import React, {useState, useContext} from "react";
import {Container, GeneralCont} from "./styleLogin";
import {ButtonLogin} from "../../routes/buttons";
import LoginLogo from "../../components/login/loginLogo";
import {ResetButton} from "../../styles/Butttons";
import ForgotPassword from "./forgotPassword/ForgotPassword";
import {AuthContext} from "../../context/AuthProvider";
import AppLoader from "../../components/loaders/Loader";

export default function Login() {
   const [mode, setMode] = useState("login");
   const {doLogin, isLoading} = useContext(AuthContext);

   const login = e => {
      e.preventDefault();
      const email = e.target.email.value;
      const pwd = e.target.pwd.value;
      doLogin(email, pwd);
   };

   return (
      <Container>
         <GeneralCont>
            {mode === "login" ? (
               <>
                  <LoginLogo />
                  <form onSubmit={login}>
                     <label htmlFor="nombre"></label>
                     <input className="styleInput" name="email" type="email" placeholder="Email" />
                     <br />

                     <label htmlFor="contraseña"></label>
                     <input className="styleInput" name="pwd" type="password" placeholder="Contraseña" />
                     <ButtonLogin>ENVIAR</ButtonLogin>
                  </form>

                  <ResetButton
                     onClick={() => {
                        setMode("recover");
                     }}
                     className="styleTxtLogin1"
                  >
                     Olvidaste tu contraseña?
                  </ResetButton>
               </>
            ) : (
               <ForgotPassword back={() => setMode("login")} />
            )}
         </GeneralCont>
         <AppLoader isVisible={isLoading} />
      </Container>
   );
}
